var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toggle-switch",on:{"click":_vm.toggle}},[_c('div',{staticClass:"toggle-track",class:{ 'is-checked': _vm.isChecked }},[_c('div',{staticClass:"toggle-thumb"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }